<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <div class="tabular">
        <div class="thead">
          <span class="head"
            >Select Reference :
            <mat-menu #appMenu="matMenu">
              <button
                mat-menu-item
                *ngFor="let refTypes of referencetypes"
                (click)="selectedValueChange(refTypes.value)"
              >
                {{ refTypes.viewValue }}
              </button>
            </mat-menu>

            <button
              mat-raised-button
              [matMenuTriggerFor]="appMenu"
              [textContent]="selectedReferenceType"
            ></button
          ></span>
          <span
            class="head"
            style="margin-left: 15px;"
            *ngIf="
              selectedReferenceType == 'Club' ||
              selectedReferenceType == 'League'
            "
            >Select Country:
            <mat-form-field>
              <mat-label>Type</mat-label>
              <mat-select
                [(value)]="selectedCountryId"
                (selectionChange)="selectedCountryChange($event)"
              >
                <mat-option
                  *ngFor="let country of countries"
                  [value]="country.id"
                >
                  {{ country.CountryName }}
                </mat-option>
              </mat-select>
            </mat-form-field></span
          >
          <span
            class="head"
            style="margin-left: 15px;"
            *ngIf="selectedReferenceType == 'StakeholderSubGroup'"
            >Select Group
            <mat-form-field>
              <mat-label>Type</mat-label>
              <mat-select
                [(value)]="selectedStakeholderGroupId"
                (selectionChange)="selectedStakeholderGroupChange($event)"
              >
                <mat-option
                  *ngFor="let group of stakeholdergroups"
                  [value]="group.id"
                >
                  {{ group.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field></span
          >
          <span
            class="head"
            style="margin-left: 15px;"
            *ngIf="selectedReferenceType == 'Organization'"
            >Select Sector
            <mat-form-field>
              <mat-label>Type</mat-label>
              <mat-select
                [(value)]="selectedStakeholderGroupId"
                (selectionChange)="selectedStakeholderGroupChange($event)"
              >
                <mat-option
                  *ngFor="let group of stakeholdergroups"
                  [value]="group.id"
                >
                  {{ group.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field></span
          >
        </div>
      </div>
    </div>
    <div class="top">
      <button class="top_button" (click)="addStakeholderReference()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search..."
            [formControl]="control"
          />
          <!-- <app-autocomplete #autocomplete="appAutocomplete">
                <ng-template appAutocompleteContent>
                  <ng-container
                    *ngIf="(stakeholderreferences | filter: control.value) as result"
                  >
                    <app-option
                      (click)="clickme(option.id)"
                      *ngFor="let option of result"
                      [value]="option.Name"
                    >
                      {{ option.Name }}
                    </app-option>
                    <app-option class="no-result" *ngIf="!result.length"
                      >No result...</app-option
                    >
                  </ng-container>
                </ng-template>
              </app-autocomplete> -->
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="tabular">
      <form [formGroup]="stakeholderreferenceForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Name</span>

          <span class="head" *ngIf="selectedReferenceType == 'Organization'"
            >Address</span
          >
          <span class="head" *ngIf="selectedReferenceType == 'Property'"
            >Location</span
          >
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="StakeholderReferences">
          <div
            class="td"
            *ngFor="
              let stakeholderreference of stakeholderreferenceForm.get(
                'StakeholderReferences'
              )['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="Name"
                placeholder="Enter text"
            /></span>

            <span *ngIf="selectedReferenceType == 'Organization'"
              ><input
                type="text"
                formControlName="Address"
                placeholder="Enter text"
            /></span>
            <span *ngIf="selectedReferenceType == 'Property'"
              ><input
                type="text"
                formControlName="Location"
                placeholder="Enter text"
            /></span>
            <span
              ><button
                class="delete_icon trash"
                (click)="
                  deleteStakeholderReference(i, stakeholderreference.value)
                "
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button
            class="submit_button"
            (click)="onSubmit(stakeholderreferenceForm.value)"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
